// extracted by mini-css-extract-plugin
export var saDefaultSlideSection = "saDefaultHeader2-module--saDefaultSlideSection--3N2pH";
export var saDefaultSlideBlock = "saDefaultHeader2-module--saDefaultSlideBlock--QMXqV";
export var saDefaultSlideImage = "saDefaultHeader2-module--saDefaultSlideImage--31ecz";
export var saDefaultSlideTitle = "saDefaultHeader2-module--saDefaultSlideTitle--mErta";
export var saDefaultSlideText = "saDefaultHeader2-module--saDefaultSlideText--3yS0s";
export var saDefaultSlideTextBefore = "saDefaultHeader2-module--saDefaultSlideTextBefore--fndgi";
export var saDefaultSlideButton = "saDefaultHeader2-module--saDefaultSlideButton--21jDo";
export var saAboutHeader = "saDefaultHeader2-module--saAboutHeader--1fCQh";
export var saDefaultSlide = "saDefaultHeader2-module--saDefaultSlide--38GL8";
export var saCommunityHeader = "saDefaultHeader2-module--saCommunityHeader--2jX7c";
export var saCommunitySec11 = "saDefaultHeader2-module--saCommunitySec11--2W_yA";